import styled from "styled-components";

import { colorFromTheme } from "../../utils/color";

// @todo the colors in here should be themeified

const H1 = styled.h1`
  color: ${colorFromTheme("h1")};
  font-weight: normal;
  font-size: 2.4rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const H2 = styled.h2`
  color: ${colorFromTheme("h2")};
  font-weight: normal;
  font-size: 2rem;
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const H3 = styled.h3`
  color: ${colorFromTheme("h3")};
  font-weight: normal;
  font-size: 1.4rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const H4 = styled.h4`
  color: ${colorFromTheme("h4")};
  font-weight: normal;
  font-size: 1.2rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Body = styled.div`
  line-height: 1.55em;

  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

const Monospace = styled(Body)`
  font-family: monospace;
  font-size: 1rem;
`;

const Text = {
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  Body: Body,
  Monospace: Monospace,
};

export default Text;
